import { Component } from '@angular/core';
import {
  LoaderService,
  MessageService,
  ValidationResultService,
} from '@shared';
import { GlobalEventsService, Tier, TiersService } from '@shared-data';

@Component({
  selector: 'app-tier-selector',
  templateUrl: './tier-selector.component.html',
  styleUrl: './tier-selector.component.scss',
})
export class TierSelectorComponent {
  tiers: Tier[] = [];
  selectedTier!: Tier;
  constructor(
    private globalEventsService: GlobalEventsService,
    private tierService: TiersService,
    private messageService: MessageService,
    private loaderService: LoaderService,
    private validationErrorService: ValidationResultService,
  ) {}

  ngOnInit() {
    this.fetchTiers();
    this.subscribeToTiersChange();
  }

  subscribeToTiersChange() {
    this.globalEventsService.tiersChanged$.subscribe(() => {
      this.fetchTiers();
    });
  }

  fetchTiers() {
    this.loaderService.show();
    this.tierService.getTiers().subscribe({
      next: (tiers) => {
        tiers = tiers.map((tier) =>
          this.tierService.handleDocumentTypesForInput(tier),
        );

        this.tiers = tiers;

        const newSelectedTier = this.tiers.find(
          (tier) => tier.id === this.selectedTier?.id,
        );
        this.onTierSelected(newSelectedTier || this.tiers[0]);

        this.loaderService.hide();
      },
      error: (error) => {
        this.messageService.error(error);
        var validationError = error?.error;
        if (validationError) {
          this.validationErrorService.show(validationError);
        }
        this.loaderService.hide();
      },
    });
  }

  onTierSelected(event: any) {
    if (event != null) {
      let tier = event as Tier;
      this.selectedTier = event;

      this.globalEventsService.updateSelectedTier(tier);
    }
  }
}
